import React, { useState, Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// Amplify
import Amplify from 'aws-amplify';

// Pages
import Home from './pages/Home';
import Error from './pages/Error';
import Books from './pages/Books';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import BookDetails from './pages/BookDetails';
import Admin from './pages/Admin';
import Header from './components/Header'
import awsExports from '../aws-exports';
import diagram from './onlineShopDiagram.svg'
Amplify.configure(awsExports);

const App = () => {
	return (
		<div>
      <Header />
			<div className="text-center p-5">
				<h1 className="mb-5">このアプリのダイアグラム</h1>
				<img src={diagram} alt="diagram" className="" />
			</div>
		</div>
	);
};

export default App;
